import React from 'react';
import {
	Button,
	Label,
	Input,
	Popover,
	PopoverContent,
	Tooltip
} from "reactstrap";
import windowStop from 'utils/windowStop.js'

const spacer = {
  marginBottom: '0.5rem',
};

const size = {
	isMobile: 768
}

const cutLenghtText = {
	'maxWidth': '122px'
}

const cutLenghtTextMobile = {
	'maxWidth': '150px'
}

export default class FilterComponent extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			popoverOpenFilter : false,
			target            : this.props.target,
			searchQuery       : '',
			filterArr         : [],
			filterElement     : '',
			filterValues			: [],
			window_width			: 0, // 768 is mobile
			tooltipOpen       : []
		}
		this.props.FBColumn.forEach((val) => {
			this.state.filterValues.push([val, false])
		})

		this.newArray = this.state.filterArr
		this.onChangeCbox = this.onChangeCbox.bind(this)
		this.toggleToolTip = this.toggleToolTip.bind(this)
	}

	toggleToolTip = targetId => {
    if(!this.state.tooltipOpen[targetId]) {
			this.setState({
				tooltipOpen: {
					...this.state.tooltipOpen,
					[targetId]: true
				}
			})
		}else {
			this.setState({
				tooltipOpen:{
					...this.state.tooltipOpen,
					[targetId]: !this.state.tooltipOpen[targetId]
				}
			})
		}
  }

	togglePopOverFilter() {
		this.setState({popoverOpenFilter: !this.state.popoverOpenFilter})
	}

	SearchKeyHandler(e) {
		if (e.key === "Enter") {
			if (typeof this.props.onSearch === 'function'){
				this.props.onSearch(this.generateSearchParam(e.target.value));
			}
		}
	}

	generateSearchParam(searchQuery){
    if(this.props.version === 2) {
      return {
        fields: this.state.filterArr.join(),
        search: searchQuery,
      }

    } else {
		  return 'fields=' + this.state.filterArr.join() + "&search=" + searchQuery;
    }
	}

	onChangeCbox(e) {
		const filters = this.state.filterValues
		let index = filters.findIndex((val)=>{ return val[0] === e.target.value})
		filters[index][1] = !filters[index][1]
    let nextState = {filterValues: filters};

    if(filters[index][1]){
      this.newArray.push(e.target.value)
      nextState.filterArr = this.newArray
    }else{
      this.newArray.splice(this.newArray.indexOf(e.target.value),1)
      nextState.filterArr = this.newArray
    }
    nextState.filterElement = this.generateFilter(this.state.filterArr)
    this.setState(nextState)
  }

  clearAll(){
		const filters = this.state.filterValues
		for (let i = 0; i < filters.length; i++){
			filters[i][1] = false
		}
		this.newArray = [];
		this.setState({
			filterValues: filters,
			filterArr: [],
			filterElement: ''
		})
  }

	generateFilterBy(){
		const {window_width} = this.state
		let a = this.state.filterValues;
		let elem = [];
		for(let i = 0; i < a.length; i++) {
			let id_tooltip = a[i][0].replace(/\s/g, '')
			let length_val = a[i][0].length
			let filter_text = (a[i][0].includes('_'))? 'Serial Number' : a[i][0]
			elem.push(
				<div className="col-md-6" key={i}>
					<div style={spacer} className="pretty p-default">
						<input
							type="checkbox"
							checked={a[i][1]}
							value={a[i][0]}
							onChange={this.onChangeCbox}
							id={id_tooltip}
						/>
						<div className="state p-primary">
							<label className="capitalize cut-text" style={window_width <= size.isMobile ? cutLenghtTextMobile : cutLenghtText} >{filter_text}</label>
						</div>
					</div>
					{length_val > 13 &&
						<Tooltip 
						placement={'bottom'} 
						isOpen={this.state.tooltipOpen[id_tooltip]} 
						target={id_tooltip} 
						toggle={() => this.toggleToolTip(id_tooltip)}
						className={'capitalize'}
					>
						{a[i][0]}
					</Tooltip>
					}
				</div>
			)
		}
		return elem;
	}

	generateFilter(filter) {
		return filter.map((val, index) => {
			return (
				<span className="badge badge-pill badge-success badge-filter-item" key={index}>{val}</span>
			);
		});
	}

	componentDidMount() {
    this.updateWindowDimensions();
    window.addEventListener('resize', this.updateWindowDimensions);
  }

  componentWillUnmount() {
  	windowStop()
    window.removeEventListener('resize', this.updateWindowDimensions);
  }

  updateWindowDimensions = () => {
    this.setState({ 
      window_width: window.innerWidth
    });
  }

	render() {
		const {defaultValue} = this.props
		const {window_width} = this.state
    let value

		return (
			<div>
				<div className="input-group">
					<div className="input-group-addon white-background">
						<Button className="btn btn-link btn-filter" id={this.state.target} onClick={()=>this.togglePopOverFilter()} >
							<i className="fa fa-filter" />&nbsp;Filter
						</Button>
						<Popover placement={window_width <= size.isMobile ? 'right' : 'bottom'} isOpen={this.state.popoverOpenFilter} target={this.state.target} toggle={()=>this.togglePopOverFilter()}>
							<PopoverContent>
								<div className="row">
									<div className="col-md-12">
										<Label>Filter By</Label>
									</div>
									<div className="col-md-12">
										<div className="row">
											{this.generateFilterBy()}
										</div>
									</div>
								</div>

								<hr />
								<div className="row">
									<div className="col-md-6">
										<Button onClick={()=>this.clearAll()} className="btn btn-sm btn-link btn-link-filter apple-red pointer" >
											Clear All
										</Button>
									</div>
									<div className="col-md-6 responsive-btn-close-popover">
										<Button className="btn btn-sm btn-link btn-link-filter apple-blue pointer " onClick={()=>this.togglePopOverFilter()}>
											Close
										</Button>
									</div>
								</div>
							</PopoverContent>
						</Popover>
					</div>
          {defaultValue === "" ?
            <Input
              type="text"
              className="form-control"
              placeholder="Search"
              name="search"
              value={value}
              onChange={event => this.setState({ searchQuery: event.target.value })}
              onKeyPress={e => this.SearchKeyHandler(e)}
            />
            :
            <Input
              type="text"
              className="form-control"
              placeholder="Search"
              name="search"
              defaultValue={defaultValue}
              onChange={event => this.setState({ searchQuery: event.target.value })}
              onKeyPress={e => this.SearchKeyHandler(e)}
              autoComplete="off"
            />
          }
				</div>
				<div className="text-muted">
					Filtered by : {this.state.filterElement}
				</div>
			</div>
		);
	}
}



// WEBPACK FOOTER //
// ./src/App/asset/simple_asset/helper/component/FilterComponent.js